import React, { useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { Plus as PlusIcon } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekDialog } from "@piiqtechnologies/ui-components";
import { CreateOrEditUserForm } from "@components/users/create-or-edit-user-form";
import { useRefetch } from "@piiqtechnologies/ui-lib";
export const CreateUser = () => {
    const intl = useIntl();
    const { setRefetch } = useRefetch();
    const [openCreateUser, setOpenCreateUser] = useState(false);
    const toggleCreateUser = () => {
        setOpenCreateUser(!openCreateUser);
        setRefetch();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { size: "large", variant: "outlined", color: "info", startIcon: React.createElement(PlusIcon, null), onClick: toggleCreateUser }, intl.formatMessage(messages.createUser)),
        React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, title: intl.formatMessage(messages.createUser), open: openCreateUser, onClose: toggleCreateUser, fullWidth: true },
            React.createElement(CreateOrEditUserForm, { isUserCreation: true, onSubmit: () => toggleCreateUser() }))));
};
export default CreateUser;
